import { render } from "./CashbackHistoricModal.vue?vue&type=template&id=723b11bc&scoped=true"
import script from "./CashbackHistoricModal.vue?vue&type=script&lang=js"
export * from "./CashbackHistoricModal.vue?vue&type=script&lang=js"

import "./CashbackHistoricModal.vue?vue&type=style&index=0&id=723b11bc&lang=scss&scoped=true"
import "./CashbackHistoricModal.vue?vue&type=style&index=1&id=723b11bc&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723b11bc"]])

export default __exports__